import React from 'react';
import iconLoginFasLogo from 'images/icon-login-faslogo@2x.png';
import styled from 'styled-components';
import { node } from 'prop-types';

const StyledContainer = styled.div`
  padding: 48px 16px 56px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StyledIconLoginFasLogo = styled.img`
  height: 80px;
`;

export const StyledCardTitle = styled.h1`
  margin: 56px 0 0 0;
  text-align: center;
`;

function Container({ children }) {
  return (
    <StyledContainer>
      <StyledIconLoginFasLogo src={iconLoginFasLogo} alt="FAS Logo" />
      {children}
    </StyledContainer>
  );
}

Container.propTypes = {
  children: node.isRequired,
};

export default Container;
